module.exports = __webpack_public_path__ + "static/media/RobotoMono-BoldItalic.39b6baa4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/RobotoMono-BoldItalic.ttf
// module id = 3686
// module chunks = 68